import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from "@angular/forms";
import { InstallmentchangeService } from "../installmentchange/shared/installmentchange.service";
import { LoanService } from "../../loan/shared/loan.service";
import { Loan } from "../../loan/shared/loan";

@Component({
  selector: 'app-installmentchange',
  templateUrl: './installmentchange.component.html',
  styleUrls: ['./installmentchange.component.css']
})
export class InstallmentchangeComponent implements OnInit {

  AddButtonText: string;
  ErrorText: string;
  InstallmentNo: number;
  readonlyTextBox: boolean = false;
  // LoanData$: any[] = [];
  loan: Loan;

  constructor(public installmentchangeService: InstallmentchangeService,
    private loanService: LoanService,
    private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.InstallmentNo = +  params['Id'];
    });

    this.resetForm();

    if (Number.isNaN(this.InstallmentNo)) {
      this.installmentchangeService.selectedInstallmentchange.Id = 0;
      this.installmentchangeService.selectedInstallmentchange.Flag = 1;
      this.installmentchangeService.selectedInstallmentchange.IsActive = true;
      this.AddButtonText = "Save";
    }
    else {
      this.installmentchangeService.selectedInstallmentchange.Id = +this.InstallmentNo;
      this.installmentchangeService.selectedInstallmentchange.Flag = 2;
      this.installmentchangeService.selectedInstallmentchange.IsActive = true;
      this.AddButtonText = "Edit & Save";
      this.getInstallmentchangeById();
    }

  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.installmentchangeService.selectedInstallmentchange = {
      Id: 0,
      LoanId: null,
      InstallmentChangeDate: new Date().toString(),
      InstallmentAmount: null,
      InstallmentOption: 0,
      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      IsActive: null,
      Flag: 0
    }
  }

  onSubmit(form: NgForm) {

    if (this.installmentchangeService.selectedInstallmentchange.LoanId != null) {
      this.installmentchangeService.IUDInstallmentChange(form.value)
        .toPromise()
        .then(data => {
          this.router.navigate(['/installmentchangelist']);
        })
    }
  }

  getLoanDeatils(loanId: any) {

    this.loan = new Loan();
    this.loan.Id = loanId;
    this.loan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.loanService.FetchLoanByLoanNo(this.loan)
      .toPromise()
      .then(data => {
        // this.LoanData$ = data;
        if (data.PaidAmount > 0) {
         // this.readonlyTextBox = true;   // temperorly hiding for startup entry
          this.ErrorText = "Installment payment already started.!";
        }
        else {
          this.readonlyTextBox = false;
          this.ErrorText = null;
        }
      })
      .catch(err => { console.log(err) });
  }

  public ClickSearch(event: any) {
    // this.getInstallmentsList(this.installmentchangeService.selectedInstallmentchange.LoanId);
    this.getLoanDeatils(this.installmentchangeService.selectedInstallmentchange.LoanId)
  }

  getInstallmentchangeById(){
    this.installmentchangeService.FetchInstallmentChangeById(this.installmentchangeService.selectedInstallmentchange)
    .toPromise()
    .then(data => {

      this.installmentchangeService.selectedInstallmentchange.Id = data.Id ;
      this.installmentchangeService.selectedInstallmentchange.LoanId = data.LoanId ;
      this.installmentchangeService.selectedInstallmentchange.InstallmentChangeDate = data.InstallmentChangeDate  ;
      this.installmentchangeService.selectedInstallmentchange.InstallmentAmount = data.InstallmentAmount ;
      this.installmentchangeService.selectedInstallmentchange.InstallmentOption = data.InstallmentOption;
    })
  }

}
